import React from 'react'

import { Box } from "@mui/material"
import { AppButtonIcon } from "@components"
import { useCustomMappingUpdate } from "Pages/User/CustomMapping/Table/@hooks"
import { LoadingIconSeeker } from "@ui-seeker/core"


export default function actionsColumn(path) {

	return {
		name: 'idCustom',
		label: 'Actions',
		options: {
			filter: false,
			setCellProps: () => ({ sx: { width: 50 } }),
			customBodyRowRenderLite: value => <RenderActionsColumn value={value} path={path}/>,
		}
	}
}

function RenderActionsColumn({ value, path }) {
	const { handleDeleteMapping, handleEditMapping, isLoadingDelete } = useCustomMappingUpdate()

	return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-around" }}>
		<AppButtonIcon
			iconWeight="solid"
			sx={{ color: "warning.main" }}
			icon="pen-to-square"
			tooltip="Edit Mapping"
			onClick={() => handleEditMapping(value, path)}
		/>
		{isLoadingDelete && <LoadingIconSeeker size={20}/>}
		{!isLoadingDelete && <AppButtonIcon
			iconWeight="solid"
			sx={{ color: "error.main" }}
			icon="trash"
			tooltip="Delete Mapping"
			onClick={() => handleDeleteMapping(value, path)}
		/>}
	</Box>
}